<template>
  <div :id="$route.params.name">
    <Header />
    <Main />
    <section class="grid grid-row-1 grid-cols-2">
      <div class="col-start-1 col-end-2">
        <address>
          Address: Milano Leather Trading LLC, Murshid Bazar, Deira, PO Box
          #112247, Dubai, United Arab Emirates
        </address>
      </div>
      <div class="col-start-2 col-end-3">
        Google:
      </div>
    </section>
    <p class="mt-16 md:mt-auto py-5 md:py-16 text-xl text-center">
      <a href="mailto://kkat.cliff@gmail.com">
        Contact us
      </a>
    </p>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Main from "@/components/body/Main.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Contact",
  components: {
    Header,
    Main,
    Footer,
  },
  mounted() {},
  computed: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss"></style>
